export default {
      id: "ic_add_account-usage",
      viewBox: "0 0 30 28",
      url: "/" + "images/icons.3.109.2.svg#ic_add_account-usage",
      toString: function () {
        return this.url;
      }
    }